import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import {schema} from "../../../Events/Events";
import {ScreenDesignerContextNew} from "../../../../../../../../../../ContextComponents/ScreenDesignerContextNew";
import Actions from "../../Actions";
import findByString from "../../../../../../../../../../Utils/Form/FormDynamic/Utils/getValueByString";

const OnClosePopupActions = (props) => {
    const {listStorage, screenValues} = useContext(ScreenDesignerContextNew);
    const {setValue, values, path} = props;
    const [isOpen, setIsOpen] = useState(false);
    const onCloseEvents = findByString(values, `${path}.events`) || [{}];
    const onCloseActions = (findByString(values, `${path}.events.0.actions`) || [{}]).map(a => a.type);
    //event index always 0
    const actionSave = (eventIndex, actions) => {
        const events = [{
            event: 'onClose',
            actions
        }];

        setValue(events, `${path}.events`)
        /*
            path + events[0].event = "onClose"
            path + events[0].actions = actions
        */
    };
    return (
        <div style={{display: 'flex', alignItems: 'center', marginTop: 10}}>
            <Typography style={{fontSize: '0.9rem', marginRight: 42}}>
                On Close
            </Typography>
            <Button variant={"text"} color={"default"}
                    onClick={() => setIsOpen(true)}
                    style={{
                        padding: '0',
                        height: 27,
                        textAlign: 'left',
                        display: 'block',
                        fontSize: 16,
                        whiteSpace: 'nowrap',
                    }}
            >
                    <span style={{textTransform: "capitalize"}}>
                        {
                            onCloseActions[0] !== undefined ?
                                onCloseActions.join(', ') :
                                ('Create New Action')
                        }
                    </span>
            </Button>
            <ScreenDesignerContextNew.Provider
                value={{
                    selectedComponent: {
                        component: {
                            events: onCloseEvents
                        }
                    },
                    listStorage,
                    screenValues,
                    actionSave
                }}
            >
                <Actions
                    open={isOpen}
                    onClose={() => setIsOpen(false)}
                    eventIndex={0}
                    schema={schema.onClosePopup.actions}
                />
            </ScreenDesignerContextNew.Provider>

        </div>
    )
};
export default OnClosePopupActions

OnClosePopupActions.propTypes = {
    setValue: PropTypes.func,
    values: PropTypes.object,
    path: PropTypes.string
};